<template>
    <b-col :md="md" class="mb-1">
        <b-form-group :label="label + ':'" :description="description" label-class="filter-header" class="mb-0">
            <b-input-group>
                <b-form-radio-group :id="id" v-model="text" @input="onFilterChange" :disabled="disabled" :options="options" class="fs-14 grey-color" />
            </b-input-group>
        </b-form-group>
    </b-col>
</template>

<script>
export default {
    name: 'filter-new-radio',
    props: {
        label: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        description: {
            type: String,
            default: ''
        },
        md: {
            default: 4
        },
        options: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        onFilterChange(value) {
            this.$emit('input', value);
        }
    },
    computed: {
        text: {
            get() {
                return this.value;
            },
            set() {
                return true;
            }
        },
        id() {
            return 'filter-new-radio_' + this._uid;
        }
    }
};
</script>

<style>
.filter-header {
    margin-left: calc(0.5rem + 2px);
    padding-bottom: 0;
    font-size: 12px;
    font-weight: bold;
}
.custom-radio > .custom-control-label > span {
    vertical-align: text-top;
}
</style>
